import axios from "axios";
import { useEffect, useReducer, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useFetchWhen from "./useFetchWhen";
import { Fetch } from "./Fetch";

const initialState = {
  dataRes: [],
  loadingRes: true,
  errorRes: null,
};

const ACTION = {
  API_REQUEST: "api-request",
  FETCH_DATA: "fetch-data",
  ERROR: "error",
};

function reducer(saveState, { type, payload }) {
  switch (type) {
    case ACTION.API_REQUEST:
      return { ...saveState, loadingRes: true, errorRes: null };
    case ACTION.FETCH_DATA:
      return { ...saveState, dataRes: payload, loadingRes: false };
    case ACTION.ERROR:
      return { ...saveState, loadingRes: false, errorRes: payload };
    default:
      return saveState;
  }
}
function useSave({
  url,
  goSave,
  setGoSave,
  newObject,
  navigateAfter = false,
  isImage = false,
  setNewData,
  setNewLoading,
  FetchUrl,
}) {
  const navigate = useNavigate();
  const [saveState, dispatch] = useReducer(reducer, initialState);
  const [dataEdited, setDataEdited] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (goSave) {
      setDataEdited(false);
      setLoading(true);
      dispatch({ type: ACTION.API_REQUEST });
      axios
        .post(url, newObject, {
          withCredentials: true,
          headers: {
            "Content-Type": isImage
              ? "multipart/form-data"
              : "application/json",
            Accept: "application/app.js",
          },
        })
        .then((res) => {
          dispatch({ type: ACTION.FETCH_DATA, payload: res?.data });
          setDataEdited(true);
          setLoading(false);
          toast.success(res?.data?.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          if (navigateAfter) {
            navigate(navigateAfter);
          }
          if (setNewData) Fetch(FetchUrl ?? url, setNewData);
        })
        .catch((err) => {
          dispatch({ type: ACTION.ERROR, payload: err.error });
          setLoading(false);
          if (err?.response?.data?.error?.errors) {
            err?.response?.data?.error?.errors.forEach((e) => {
              toast.error(e.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            });
          } else if (err?.response?.data?.error) {
            toast.error(err?.response?.data?.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        });
      setGoSave(false);
    }
  }, [goSave]);
  return { saveState, loading };
}

export default useSave;
